import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MessageCircle, Loader2 } from "lucide-react";

export default function ScanLanding() {
  const { slug } = useParams();
  const [preview, setPreview] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.getPreview(slug).then((p) => {
      setPreview(p);
      if (p && (!p.capture_lead || !p.active)) window.location.replace(p.target);
    }).catch(() => {});
  }, [slug]);

  const proceed = async (withDetails) => {
    setSubmitting(true);
    try {
      const res = await api.recordScan(slug, withDetails ? { name: name.trim() || null, phone: phone.trim() || null } : {});
      window.location.replace(res.target);
    } catch {
      if (preview?.target) window.location.replace(preview.target);
    }
  };

  const eventName = preview?.active_event?.name;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-7 fade-up" data-testid="scan-landing">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="grid h-11 w-11 place-items-center rounded-2xl bg-accent text-accent-foreground">
            <MessageCircle className="h-6 w-6" strokeWidth={2} />
          </div>
          <div>
            <h1 className="font-display text-2xl font-extrabold tracking-tighter leading-none">Almost there!</h1>
            {eventName && <p className="text-xs text-muted-foreground mt-1">You're connecting via {eventName}</p>}
          </div>
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed mb-6">
          Share your details so we can stay in touch, then continue to WhatsApp.
        </p>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="s-name">Your name</Label>
            <Input id="s-name" data-testid="scan-name-input" placeholder="e.g. Priya Sharma" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="s-phone">Your WhatsApp number</Label>
            <Input id="s-phone" data-testid="scan-phone-input" placeholder="e.g. 919876543210" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
        </div>
        <div className="mt-7 space-y-3">
          <Button data-testid="scan-continue-btn" onClick={() => proceed(true)} disabled={submitting}
            className="w-full rounded-full bg-accent text-accent-foreground hover:bg-accent/90 active:scale-[0.98] transition-transform duration-150">
            {submitting ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <MessageCircle className="h-4 w-4 mr-2" />}
            Continue to WhatsApp
          </Button>
          <button data-testid="scan-skip-btn" onClick={() => proceed(false)} disabled={submitting}
            className="w-full text-center text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
            Skip and continue
          </button>
        </div>
      </div>
    </div>
  );
}
